import { getToken, onMessage } from "firebase/messaging";
import type { MessagePayload } from "firebase/messaging";
import { getMessagingInstance } from ".";
import { NotificationApi } from "../apis";

const VAPID_KEY = "BFqNvzW9mQg4zW_ClUPa-0MOYideF61P9d0m938JSE9dCe_Zwil7DOT0r0wnUW8nyxaIdnC60qO0Jrt3Ikzk3dI";

export const requestForToken = async () => {
  try {
    if (typeof Notification === "undefined") return;
    const messaging = await getMessagingInstance();
    if (!messaging) return;
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return;
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    await NotificationApi.firebaseToken({ fcmToken: token });
    return token;
  } catch (error) {
    console.error("Error getting FCM token:", error);
  }
};

export const onMessageListener = async (
  callback: (payload: MessagePayload, unsubscribe: () => void) => void
) => {
  const messaging = await getMessagingInstance();
  if (!messaging) return;
  const unsub = onMessage(messaging, (payload) => callback(payload, unsub));
};
